// =========================================================
// SECTION NEWS — carousel Splide des articles, MÊME LOGIQUE que les
// promotions (demande Olivier) : flèches custom du header, largeur de carte
// calculée (N cartes visibles dont la dernière coupée), butées détectées par
// la POSITION (trimSpace clampe le translate avant le dernier index), autoplay
// maison jusqu'à la 1ʳᵉ interaction, bleed droit. Cartes plus larges que les
// promos → moins de cartes visibles (2.75 / 1.8 / 1.15).
// =========================================================
import Splide from '@splidejs/splide';

document.addEventListener('DOMContentLoaded', () => {

    document.querySelectorAll('.km-news').forEach((section) => {
        const el = section.querySelector('.km-news__splide');
        if (!el || el.dataset.kmNewsInitialized) return;
        el.dataset.kmNewsInitialized = '1';

        const GAP = 32;
        // MÊMES largeurs de carte que les promos (retour Olivier — même avec
        // peu d'articles, le gabarit reste aligné sur la section actions/promos)
        const visibleCount = () => window.innerWidth < 768 ? 1.15 : (window.innerWidth < 1200 ? 2.5 : 3.5);
        const cardWidth = () => {
            const track = el.querySelector('.splide__track').clientWidth;
            const n = visibleCount();
            return Math.floor((track - Math.ceil(n - 1) * GAP) / n);
        };

        const splide = new Splide(el, {
            type: 'slide',
            rewind: true, // l'autoplay reboucle au début en fin de piste
            perMove: 1,
            gap: GAP + 'px',
            fixedWidth: cardWidth() + 'px',
            trimSpace: true,
            pagination: false,
            arrows: false, // flèches custom du header
            breakpoints: {
                767: {pagination: true}, // mobile : bullets + swipe (pattern promos)
            },
            // ⚠️ Splide passe speed à 0 en « Réduire les animations » — glisse conservée
            reducedMotion: {speed: 400, rewindSpeed: 400},
        });

        splide.mount();
        el.splide = splide;

        let raf = null;
        window.addEventListener('resize', () => {
            if (raf) cancelAnimationFrame(raf);
            raf = requestAnimationFrame(() => {
                splide.options = {fixedWidth: cardWidth() + 'px'};
            });
        });

        const prev = section.querySelector('.km-news__arrow--prev');
        const next = section.querySelector('.km-news__arrow--next');

        // ⚠️ Index RÉELLEMENT atteignable (translate clampé par trimSpace au-delà
        // → clics « morts », leçon promos)
        const lastReachable = () => {
            const limit = Math.abs(splide.Components.Move.getLimit(true));
            return Math.max(0, Math.min(splide.length - 1, Math.ceil(limit / (cardWidth() + GAP))));
        };

        const refresh = () => {
            const Move = splide.Components.Move;
            const atEnd = Math.abs(Move.getPosition() - Move.getLimit(true)) < 2;
            const atStart = Math.abs(Move.getPosition() - Move.getLimit(false)) < 2;
            section.classList.toggle('is-end', atEnd);
            if (prev) prev.toggleAttribute('disabled', atStart);
            if (next) next.toggleAttribute('disabled', atEnd);
        };
        ['mounted', 'moved', 'resized'].forEach((e) => splide.on(e, refresh));
        refresh();

        // Anticipation : .is-end posé dès le DÉBUT du déplacement (leçon promos)
        splide.on('move', (newIndex) => {
            const endIdx = lastReachable();
            section.classList.toggle('is-end', newIndex >= endIdx);
            if (next) next.toggleAttribute('disabled', newIndex >= endIdx);
            if (prev) prev.toggleAttribute('disabled', newIndex === 0);
        });

        // AUTOPLAY MAISON (leçon promos : l'Autoplay Splide dérive d'index en
        // butée trimSpace) — avance jusqu'à la butée visuelle puis revient au
        // début ; pause au survol (:hover interrogé EN DIRECT), stop définitif
        // à la 1ʳᵉ interaction.
        let userInteracted = false;
        setInterval(() => {
            if (userInteracted || section.matches(':hover') || document.hidden) return;
            const Move = splide.Components.Move;
            const atEnd = Math.abs(Move.getPosition() - Move.getLimit(true)) < 2;
            splide.go(atEnd ? 0 : Math.min(splide.index + 1, lastReachable()));
        }, 4000);

        const stopAutoplay = () => { userInteracted = true; };
        splide.on('drag', stopAutoplay);
        el.querySelector('.splide__pagination')?.addEventListener('click', stopAutoplay);
        if (prev) prev.addEventListener('click', () => {
            stopAutoplay();
            splide.go(Math.max(0, Math.min(splide.index - 1, lastReachable() - 1)));
        });
        if (next) next.addEventListener('click', () => {
            stopAutoplay();
            splide.go(Math.min(splide.index + 1, lastReachable()));
        });
    });

});
